"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenAndConcatenateKeysWithNamespace = void 0;
/**
 * Flattens and concatenates translation keys with namespaces to create a flat Translations object for intl provider uses.
 * @example
 * const translationsWithNamespaces = {
 *   common: {
 *     greeting: 'Hello',
 *     farewell: 'Goodbye',
 *   },
 *   dashboard: {
 *     title: 'Dashboard',
 *     subtitle: 'Welcome to the dashboard!',
 *   },
 * };
 *
 * // Call the function to flatten and concatenate keys.
 * const flattenedTranslations = flattenAndConcatenateKeysWithNamespace(translationsWithNamespaces);
 * // The resulting flattenedTranslations object will contain:
 * // {
 * //   'common:greeting': 'Hello',
 * //   'common:farewell': 'Goodbye',
 * //   'dashboard:title': 'Dashboard',
 * //   'dashboard:subtitle': 'Welcome to the dashboard!',
 * // }
 *
 * @typeParam T Type of the translations with namespaces object.
 * @param translationsWithNamespaces The translations object with namespaces.
 * @returns Flattened and concatenated translation keys with values.
 */ var flattenAndConcatenateKeysWithNamespace = function(translationsWithNamespaces) {
    return Object.keys(translationsWithNamespaces).reduce(function(output, namespace) {
        var result = _object_spread({}, output);
        var namespaceData = translationsWithNamespaces[namespace];
        if (namespaceData) {
            Object.keys(namespaceData).forEach(function(key) {
                var value = namespaceData[key];
                if (value != null && value !== '') {
                    var concatenatedKey = "".concat(namespace, ":").concat(key);
                    result[concatenatedKey] = value;
                }
            });
        }
        return result;
    }, {});
};
exports.flattenAndConcatenateKeysWithNamespace = flattenAndConcatenateKeysWithNamespace; //# sourceMappingURL=flattenAndConcatenateKeysWithNamespace.js.map
